import { render, staticRenderFns } from "./Sender.vue?vue&type=template&id=d889b348&scoped=true"
import script from "./Sender.vue?vue&type=script&lang=js"
export * from "./Sender.vue?vue&type=script&lang=js"
import style0 from "./Sender.vue?vue&type=style&index=0&id=d889b348&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d889b348",
  null
  
)

export default component.exports